// Footer.js
import React from 'react';
import { Link } from 'react-router-dom'; 
import '../CSS/Global.css';
import FooterLogo from '../img/logo art director.png'

const Footer = () => {
    return (
        <footer className="footer">
            <div className="footer-container">
                <div className="footer-section about">
                    <div className="foooter-logo">
                        <img src={FooterLogo} alt="" />
                    </div>
                    <p>Mazhar Khan has an impressive portfolio spanning over 30 projects in television, films, and advertisements.</p>
                </div>

                <div className="footer-section links">
                    <h3>Quick Links</h3>
                    <ul>
                        <li><Link to="/"> <i className="fa-solid fa-chevron-right"></i> Home</Link></li>
                        <li><Link to="/about"> <i className="fa-solid fa-chevron-right"></i> About</Link></li>
                        <li><Link to="/projects"> <i className="fa-solid fa-chevron-right"></i> My Projects</Link></li>
                        <li><Link to="/contact"> <i className="fa-solid fa-chevron-right"></i> Contact</Link></li>
                    </ul>
                </div>

                {/* <div className="footer-section support">
                    <h3>Support</h3>
                    <ul>
                        <li><Link to="/privacy-policy"> <i className="fa-solid fa-chevron-right"></i> Privacy Policy</Link></li>
                        <li><Link to="/terms-and-conditions"> <i className="fa-solid fa-chevron-right"></i> Terms & Conditions</Link></li>
                        {/* <li><Link to="/support"> <i className="fa-solid fa-chevron-right"></i> Support</Link></li>
                        <li><Link to="/disclaimer"> <i className="fa-solid fa-chevron-right"></i> Disclaimer</Link></li> 
                    </ul>
                </div> */}

                <div className="footer-section contact">
                    <h3>Contact Info</h3>
                    <p><i className="fas fa-location-dot"></i> 8/42 shri saibaba nagar vira desai road, andheri west,mumbai - 400053</p>
                    <p><i className="fas fa-envelope"></i> mazharkhan189@yahoo.co.in</p>
                    <p><i className="fas fa-phone"></i> +91-9821290637</p>
                    <button className="follow-btn">Follow Us</button>
                    <div className="social-icons">
                        <i className="fab fa-facebook social-icon"></i>
                        <i className="fab fa-instagram social-icon"></i>
                        <i className="fab fa-whatsapp social-icon"></i>
                    </div>
                </div>
            </div>

            <p className="footer-copyright">
                Copyright © | Created By <a href="https://100billiontech.com/" target="_blank" rel="noopener noreferrer">100Billion Tech</a>
            </p>

        </footer>
    );
};

export default Footer;
